module.exports = __webpack_public_path__ + "img/jakocoinhave.138511f0.svg";